import { useEffect, useState } from 'react';
import styles from './ContactForm.module.scss';
import { getRequest } from '@/services/api';

const FALLBACK_IMAGING_TEST_OPTIONS: any = {
	MRI: {
		dropdownValues: [
			'Ascot (from £375)',
			'Bath (from £555, inclusive of a consultation with a senior physiotherapist)',
			'Birmingham (from £350)',
			'Cardiff (from £350)',
			'Edinburgh (from £540)',
			'Glasgow (from £350)',
			'Lincolnshire (from £616)',
			'Liverpool (from £350)',
			'London (from £350)',
			'Manchester (from £350)',
			'Peterborough (from £350)',
		],
		note: "To note: The price below is the starting price for ONE part, which may increase subject to locations and/or the specific requirements in the clinician's referral letters. All imaging prices include Nord customers' discount.",
	},
	'X-Ray': {
		dropdownValues: [
			'Ascot (from £170)',
			'Bath (from £305 incl. a consultation with a senior physiotherapist)',
			'Belfast (admin fee £70 + scan fee to facility starting from £111)',
			'Edinburgh (from £195)',
			'Lincolnshire (from £220)',
			'Liverpool (from £150)',
			'London (from £150)',
			'Manchester (from £255)',
			'Werndale (Wales) (from £220)',
			'Chelmsford CM2 8HN (from £150)',
			'Other',
		],
		note: "To note: The price below is the starting price for ONE part, which may increase subject to locations and/or the specific requirements in the clinician's referral letters. All imaging prices include Nord customers' discount.",
	},
	Ultrasound: {
		dropdownValues: [
			'Ascot (from £415)',
			'Edinburgh (from £400)',
			'Lincolnshire (from £458)',
			'Liverpool (from £195)',
			'London (from £195)',
			'Manchester (from £195)',
			'Werndale (Wales) (from £503)',
			'Other',
		],
		note: "To note: The price below is the starting price for ONE part, which may increase subject to locations and/or the specific requirements in the clinician's referral letters. All imaging prices include Nord customers' discount.",
	},
	'CT scan': {
		dropdownValues: [
			'Ascot',
			'Edinburgh',
			'Lincolnshire',
			'Liverpool',
			'London',
			'Manchester',
			'Milton Keynes',
			'Other',
		],
		note: 'To note: We are currently updating our provider pricing for this investigation - please email us if you would like the price for a certain location.',
	},
};

export const BloodTestForm = ({ formData, handleChange, handleBooleanToggle }: any) => {
	const bloodTestTypeOptions: any = {
		// Nord
		'Orthopaedic Blood Test': {
			price: '178.20',
			note: 'We are unable to perform this as a home visit.',
		},
		'Plastic Surgeries': {
			price: '161.10',
			note: 'A home visit may or may not incur an additional charge (differs on case-by-case basis).',
		},
		'Bariatric Surgeries': {
			price: '161.10',
			note: 'A home visit may or may not incur an additional charge (differs on case-by-case basis).',
		},
		'Full-op Bariatric Surgeries': {
			price: '178.20',
			note: 'We are unable to perform this as a home visit.',
		},
		// Diers
		'IUI Diers Test Profile 1': {
			price: '148.00',
			note: 'Home visit phlebotomy may incur an extra charge depending on location.',
		},
		'IUI Diers Test Profile 2 (by Post)': {
			price: '89.00',
			note: 'Include: a test kit, a pre-paid Track24 label to return the samples back to the lab, and the test result report.',
		},
		'IUI Diers Test Profile 3 (by Post; AMH)': {
			price: '66.00',
			note: 'Include: a test kit, a pre-paid Track24 label to return the samples back to the lab, and the test result report.',
		},
		'IUI Diers Test Profile 4 (by Post; Progesterone)': {
			price: '50.00',
			note: 'Include: a test kit, a pre-paid Track24 label to return the samples back to the lab, and the test result report.',
		},
		'IVF Diers Test Profile 1': {
			price: '148.00',
			note: 'Home visit phlebotomy may incur an extra charge depending on location.',
		},
		'IVF Diers Test Profile 2': {
			price: '178.00',
			note: 'Home visit phlebotomy may incur an extra charge depending on location.',
		},
		'IVF Diers Test Profile 3 (Men)': {
			price: '168.00',
			note: 'Home visit phlebotomy may incur an extra charge depending on location.',
		},
		'IVF Diers Test Profile 4 (Women using their own eggs)': {
			price: '212.00',
			note: 'Home visit phlebotomy may incur an extra charge depending on location.',
		},
		'IVF - Rubella IgG (by post)': {
			price: '52.00',
			note: 'Home visit phlebotomy may incur an extra charge depending on location.',
		},
	};

	return (
		<>
			<label htmlFor="badBloodExtractionExperience">
				Have you ever had any <u>bad experiences</u> while having your blood drawn? (e.g. fear of
				blood, needle phobia, dizziness, difficult veins)
			</label>
			<div className={styles['toggle-buttons']}>
				<button
					type="button"
					className={`${styles['toggle-button']} ${
						formData.badBloodExtractionExperience === true ? styles['active'] : ''
					}`}
					onClick={() => handleBooleanToggle('badBloodExtractionExperience', true)}
				>
					Yes
				</button>

				<button
					type="button"
					className={`${styles['toggle-button']} ${
						formData.badBloodExtractionExperience === false ? styles['active'] : ''
					}`}
					onClick={() => handleBooleanToggle('badBloodExtractionExperience', false)}
				>
					No
				</button>
			</div>

			{formData.badBloodExtractionExperience && (
				<>
					<label htmlFor="badBloodExtractionExperienceExplanation">
						Please elaborate on this, with as much detail as possible.
					</label>
					<input
						type="text"
						id="badBloodExtractionExperienceExplanation"
						name="badBloodExtractionExperienceExplanation"
						value={formData.badBloodExtractionExperienceExplanation}
						onChange={handleChange}
					/>
				</>
			)}

			<label htmlFor="bloodTestTypeRequired">Select which blood test you require.</label>
			<select
				id="bloodTestTypeRequired"
				name="bloodTestTypeRequired"
				value={formData.bloodTestTypeRequired}
				onChange={handleChange}
				required
				className={styles['form-select']}
			>
				<option value="" disabled>
					Select your answer
				</option>
				{formData.referringClinician === 'Nord Clinic' && (
					<>
						<option value="Orthopaedic Blood Test">
							Pre-operative test (Orthopaedic Blood Test)
						</option>
						<option value="Plastic Surgeries">Pre-operative test (Plastic Surgeries)</option>
						<option value="Bariatric Surgeries">Pre-operative test (Bariatric Surgeries)</option>
						<option value="Full-op Bariatric Surgeries">
							Full post-op follow-up blood test package (Bariatric Surgeries)
						</option>
					</>
				)}

				{formData.referringClinician === 'Diers Fertility Clinic' && (
					<>
						<optgroup label="Fertility Treatment (IUI)">
							<option value="IUI Diers Test Profile 1">IUI Diers Test Profile 1</option>
							<option value="IUI Diers Test Profile 2 (by Post)">
								IUI Diers Test Profile 2 (by Post)
							</option>
							<option value="IUI Diers Test Profile 3 (by Post; AMH)">
								IUI Diers Test Profile 3 (by Post; AMH)
							</option>
							<option value="IUI Diers Test Profile 4 (by Post; Progesterone)">
								IUI Diers Test Profile 4 (by Post; Progesterone)
							</option>
						</optgroup>
						<optgroup label="Fertility Treatment (IVF)">
							<option value="IVF Diers Test Profile 1">IVF Diers Test Profile 1</option>
							<option value="IVF Diers Test Profile 2">IVF Diers Test Profile 2</option>
							<option value="IVF Diers Test Profile 3 (Men)">IVF Diers Test Profile 3 (Men)</option>
							<option value="IVF Diers Test Profile 4 (Women using their own eggs)">
								IVF Diers Test Profile 4 (Women using their own eggs)
							</option>
							<option value="IVF - Rubella IgG (by post)">IVF - Rubella IgG (by post)</option>
						</optgroup>
					</>
				)}

				{formData.referringClinician === `Centre For Men's Health` && (
					<>
						<option value="CFMH01 - Male hormone">CFMH01 - Male hormone</option>
						<option value="Nebido injections">Nebido injections</option>
					</>
				)}
				<>
					<option value="Other Blood Test">Other</option>
				</>
			</select>

			{formData.bloodTestTypeRequired === 'Other Blood Test' && (
				<>
					<label htmlFor="otherBloodTestTypeRequired">Please specify.</label>
					<input
						type="text"
						id="otherBloodTestTypeRequired"
						name="otherBloodTestTypeRequired"
						value={formData.otherBloodTestTypeRequired}
						onChange={handleChange}
					/>
				</>
			)}

			{formData.bloodTestTypeRequired && (
				<>
					<label htmlFor={'firstMostSuitableLocation'}>
						Please select the <u>most suitable</u> location to have your{' '}
						<b>{formData.bloodTestTypeRequired}</b> performed.
					</label>
					{formData.bloodTestTypeRequired !== 'Other Blood Test' &&
						bloodTestTypeOptions[formData.bloodTestTypeRequired]?.price && (
							<small>
								The price for this test starts at{' '}
								<strong>£{bloodTestTypeOptions[formData.bloodTestTypeRequired]?.price}</strong>{' '}
								{formData.referringClinician === 'Nord Clinic'
									? 'inclusive of a 10% Nord customer discount'
									: ''}
								.
								<br />
								<em>{bloodTestTypeOptions[formData.bloodTestTypeRequired]?.note}</em>
							</small>
						)}
					<select
						id="firstMostSuitableLocation"
						name="firstMostSuitableLocation"
						value={formData.firstMostSuitableLocation}
						onChange={handleChange}
						className={styles['form-select']}
					>
						<option value="" disabled>
							Select a location
						</option>
						<option value="Belfast">Belfast</option>
						<option value="Bristol">Bristol</option>
						<option value="Cambridge">Cambridge</option>
						<option value="Cardiff">Cardiff</option>
						<option value="Coventry">Coventry</option>
						<option value="Edinburgh">Edinburgh</option>
						<option value="Glasgow">Glasgow</option>
						<option value="Grimsby">Grimsby</option>
						<option value="Liverpool">Liverpool</option>
						<option value="London NW9">London NW9</option>
						<option value="London, Wimpole Street">London, Wimpole Street</option>
						<option value="Manchester">Manchester</option>
						<option value="Newport">Newport</option>
						<option value="Swansea">Swansea</option>
						<option value="Other">Other</option>
					</select>

					{formData.firstMostSuitableLocation === 'Other' && (
						<div className={styles['form-group']}>
							<label htmlFor="firstOtherLocation">Please specify your location</label>
							<input
								type="text"
								id="firstOtherLocation"
								name="firstOtherLocation"
								value={formData.otherLocation}
								onChange={handleChange}
								required
								className={styles['form-select']}
							/>
						</div>
					)}

					<label htmlFor={'secondMostSuitableLocation'}>
						Please select the <u>second most suitable</u> location to have your{' '}
						<b>{formData.bloodTestTypeRequired}</b> performed.
					</label>
					{formData.bloodTestTypeRequired !== 'Other Blood Test' &&
						bloodTestTypeOptions[formData.bloodTestTypeRequired]?.price && (
							<small>
								The price for this test starts at{' '}
								<strong>£{bloodTestTypeOptions[formData.bloodTestTypeRequired]?.price}</strong>{' '}
								{formData.referringClinician === 'Nord Clinic'
									? 'inclusive of a 10% Nord customer discount'
									: ''}
								.
								<br />
								<em>{bloodTestTypeOptions[formData.bloodTestTypeRequired]?.note}</em>
							</small>
						)}
					<select
						id="secondMostSuitableLocation"
						name="secondMostSuitableLocation"
						value={formData.secondMostSuitableLocation}
						onChange={handleChange}
						className={styles['form-select']}
					>
						<option value="" disabled>
							Select a location
						</option>
						<option value="Belfast">Belfast</option>
						<option value="Bristol">Bristol</option>
						<option value="Cambridge">Cambridge</option>
						<option value="Cardiff">Cardiff</option>
						<option value="Coventry">Coventry</option>
						<option value="Edinburgh">Edinburgh</option>
						<option value="Glasgow">Glasgow</option>
						<option value="Grimsby">Grimsby</option>
						<option value="Liverpool">Liverpool</option>
						<option value="London NW9">London NW9</option>
						<option value="London, Wimpole Street">London, Wimpole Street</option>
						<option value="Manchester">Manchester</option>
						<option value="Newport">Newport</option>
						<option value="Swansea">Swansea</option>
					</select>
				</>
			)}
		</>
	);
};

export const ImageScanForm = ({ formData, handleChange, handleBooleanToggle }: any) => {
	const [imagingTestOptions, setImagingTestOptions] = useState<any>(FALLBACK_IMAGING_TEST_OPTIONS);

	useEffect(() => {
		const fetchImagingTestOptions = async () => {
			try {
				const response = await getRequest('/contact/imaging-locations');
				if (response.status === 'success' && Array.isArray(response.data)) {
					const options: any = {};

					response.data.forEach(
						(item: { scan_type: string; location: string; price_description?: string }) => {
							const scanTypeKey = item.scan_type.trim(); // Imaging test, i.e. X-ray, CT Scan
							const location = item.location;
							const price_description = item.price_description;

							if (!options[scanTypeKey]) {
								options[scanTypeKey] = {
									dropdownValues: [],
									note: "To note: The price below is the starting price for ONE part, which may increase subject to locations and/or the specific requirements in the clinician's referral letters. All imaging prices include Nord customers' discount.",
								};
							}

							// Combine the location string with price description if available
							const locationWithPrice = price_description
								? `${location} (${price_description})`
								: location;

							if (!options[scanTypeKey].dropdownValues.includes(locationWithPrice)) {
								options[scanTypeKey].dropdownValues.push(locationWithPrice);
							}
						}
					);

					setImagingTestOptions(options);
				} else {
					console.error('Failed to fetch imaging test options:', response.message);
				}
			} catch (error) {
				console.error('Error loading imaging test options:', error);
			}
		};

		fetchImagingTestOptions();
	}, []);

	return (
		<>
			<label htmlFor="medicalDetailForImageScan">
				Please provide a brief summary of medical details that lead to your seeking treatment and
				imaging scans.
			</label>
			<input
				type="text"
				id="medicalDetailForImageScan"
				name="medicalDetailForImageScan"
				value={formData.medicalDetailForImageScan}
				onChange={handleChange}
			/>

			<label htmlFor="explainedBodyPart">
				Please specify <u>what</u> part of the body this is for and <u>which side</u> you need
				imaged - NOTE: if you require both sides, or multiple areas of the body, then please
				indicate this below, as this will determine the price.
			</label>
			<small>
				For example, left hip x-ray OR right knee MRI OR ultrasound of abdomen and testes
			</small>
			<input
				type="text"
				id="explainedBodyPart"
				name="explainedBodyPart"
				value={formData.explainedBodyPart}
				onChange={handleChange}
			/>

			<label htmlFor="imageTestTypeRequested">
				Select <u>which imaging test</u> you require.
			</label>
			<select
				id="imageTestTypeRequested"
				name="imageTestTypeRequested"
				value={formData.imageTestTypeRequested}
				onChange={handleChange}
				className={styles['form-select']}
			>
				<option value="" disabled>
					Select your answer
				</option>
				{/* Dynamically generate options from imagingTestOptions keys */}
				{Object.keys(imagingTestOptions).map((scanType) => (
					<option key={scanType} value={scanType}>
						{scanType}
					</option>
				))}
				<option value="Other">Other</option>
			</select>

			{formData.imageTestTypeRequested && formData.imageTestTypeRequested !== 'Other' && (
				<>
					<label htmlFor="imagingLocation">
						Please select the <u>most</u> preferred location to have your{' '}
						<u>{formData.imageTestTypeRequested}</u> performed.
					</label>

					{imagingTestOptions[formData.imageTestTypeRequested]?.note && (
						<small>
							<em>{imagingTestOptions[formData.imageTestTypeRequested].note}</em>
						</small>
					)}

					<select
						id="firstMostPreferredImageTestLocation"
						name="firstMostPreferredImageTestLocation"
						value={formData.firstMostPreferredImageTestLocation}
						onChange={handleChange}
						className={styles['form-select']}
					>
						<option value="" disabled>
							Select a location
						</option>
						{imagingTestOptions[formData.imageTestTypeRequested]?.dropdownValues.map(
							(option: any) => (
								<option key={option} value={option}>
									{option}
								</option>
							)
						)}
					</select>

					<label htmlFor="imagingLocation">
						Please select the <u>second-most</u> preferred location to have your{' '}
						<u>{formData.imageTestTypeRequested}</u> performed.
					</label>

					{imagingTestOptions[formData.imageTestTypeRequested]?.note && (
						<small>
							<em>{imagingTestOptions[formData.imageTestTypeRequested].note}</em>
						</small>
					)}

					<select
						id="secondMostPreferredImageTestLocation"
						name="secondMostPreferredImageTestLocation"
						value={formData.secondMostPreferredImageTestLocation}
						onChange={handleChange}
						className={styles['form-select']}
					>
						<option value="" disabled>
							Select a location
						</option>
						{imagingTestOptions[formData.imageTestTypeRequested]?.dropdownValues.map(
							(option: any) => (
								<option key={option} value={option}>
									{option}
								</option>
							)
						)}
					</select>

					{formData.secondMostPreferredImageTestLocation && (
						<>
							<label htmlFor="heartFitterInstalledMRI">
								Do you have or Have you ever had a cardiac pacemaker or valve or internal
								defibrillator fitter to your heart? If "YES" - unable to proceed with scan *
							</label>
							<div className={styles['checkbox-group']}>
								<label>
									<input
										type="checkbox"
										name="heartFitterInstalledMRI"
										value="Yes"
										checked={formData.heartFitterInstalledMRI.includes('Yes')}
										onChange={handleChange}
									/>
									Yes
								</label>
								<label>
									<input
										type="checkbox"
										name="heartFitterInstalledMRI"
										value="No"
										checked={formData.heartFitterInstalledMRI.includes('No')}
										onChange={handleChange}
									/>
									No
								</label>
							</div>

							<label htmlFor="shuntOrClipInstalledMRI">
								Do you have an intracranial aneurysm clip or a programmable ventriculoperitoneal
								shunt? If "YES" - unable to proceed with scan *
							</label>
							<div className={styles['checkbox-group']}>
								<label>
									<input
										type="checkbox"
										name="shuntOrClipInstalledMRI"
										value="Yes"
										checked={formData.shuntOrClipInstalledMRI.includes('Yes')}
										onChange={handleChange}
									/>
									Yes
								</label>
								<label>
									<input
										type="checkbox"
										name="shuntOrClipInstalledMRI"
										value="No"
										checked={formData.shuntOrClipInstalledMRI.includes('No')}
										onChange={handleChange}
									/>
									No
								</label>
							</div>

							<label htmlFor="implantOrNeurotransmitterMRI">
								Have you had a cochlear implant or neurotransmitter? If "YES" - unable to proceed
								with scan *
							</label>
							<div className={styles['checkbox-group']}>
								<label>
									<input
										type="checkbox"
										name="implantOrNeurotransmitterMRI"
										value="Yes"
										checked={formData.implantOrNeurotransmitterMRI.includes('Yes')}
										onChange={handleChange}
									/>
									Yes
								</label>
								<label>
									<input
										type="checkbox"
										name="implantOrNeurotransmitterMRI"
										value="No"
										checked={formData.implantOrNeurotransmitterMRI.includes('No')}
										onChange={handleChange}
									/>
									No
								</label>
							</div>

							<label htmlFor="renalImpairmentMRI">
								Do you have renal impairment? If "YES" – an extrapolated GFR should be determined
								from the serum creatinine and discussed with LCAD *
							</label>
							<div className={styles['checkbox-group']}>
								<label>
									<input
										type="checkbox"
										name="renalImpairmentMRI"
										value="Yes"
										checked={formData.renalImpairmentMRI.includes('Yes')}
										onChange={handleChange}
									/>
									Yes
								</label>
								<label>
									<input
										type="checkbox"
										name="renalImpairmentMRI"
										value="No"
										checked={formData.renalImpairmentMRI.includes('No')}
										onChange={handleChange}
									/>
									No
								</label>
							</div>

							<label htmlFor="proceduresSixMonthsMRI">
								Have you had any surgery or procedures carried out in the last 6 weeks? If "YES" –
								unable to proceed with scan *
							</label>
							<div className={styles['checkbox-group']}>
								<label>
									<input
										type="checkbox"
										name="proceduresSixMonthsMRI"
										value="Yes"
										checked={formData.proceduresSixMonthsMRI.includes('Yes')}
										onChange={handleChange}
									/>
									Yes
								</label>
								<label>
									<input
										type="checkbox"
										name="proceduresSixMonthsMRI"
										value="No"
										checked={formData.proceduresSixMonthsMRI.includes('No')}
										onChange={handleChange}
									/>
									No
								</label>
							</div>

							<label htmlFor="metallicForeignBodiesEyeMRI">
								Is there a history of metallic foreign bodies in your eye? If "YES" – it is
								mandatory to exclude metallic orbital foreign bodies by orbital X-ray. If no
								metallic foreign body is detected, scan can proceed. If detected, unable to proceed
								*
							</label>
							<div className={styles['checkbox-group']}>
								<label>
									<input
										type="checkbox"
										name="metallicForeignBodiesEyeMRI"
										value="Yes"
										checked={formData.metallicForeignBodiesEyeMRI.includes('Yes')}
										onChange={handleChange}
									/>
									Yes
								</label>
								<label>
									<input
										type="checkbox"
										name="metallicForeignBodiesEyeMRI"
										value="No"
										checked={formData.metallicForeignBodiesEyeMRI.includes('No')}
										onChange={handleChange}
									/>
									No
								</label>
							</div>

							<label htmlFor="breastFeedingMRI">
								Are you breastfeeding (female customers)? If "YES" - intravenous contrast cannot be
								administered while breastfeeding and the patient should contact LCAD for
								instructions *
							</label>
							<div className={styles['checkbox-group']}>
								<label>
									<input
										type="checkbox"
										name="breastFeedingMRI"
										value="Yes"
										checked={formData.breastFeedingMRI.includes('Yes')}
										onChange={handleChange}
									/>
									Yes
								</label>
								<label>
									<input
										type="checkbox"
										name="breastFeedingMRI"
										value="No"
										checked={formData.breastFeedingMRI.includes('No')}
										onChange={handleChange}
									/>
									No
								</label>
								<label>
									<input
										type="checkbox"
										name="breastFeedingMRI"
										value="N/A"
										checked={formData.breastFeedingMRI.includes('N/A')}
										onChange={handleChange}
									/>
									Not Applicable
								</label>
							</div>

							<label htmlFor="pregnantMRI">
								Is there any chance that you may be pregnant (female customer)? If "YES" - unable to
								proceed with scan *
							</label>
							<div className={styles['checkbox-group']}>
								<label>
									<input
										type="checkbox"
										name="pregnantMRI"
										value="Yes"
										checked={formData.pregnantMRI.includes('Yes')}
										onChange={handleChange}
									/>
									Yes
								</label>
								<label>
									<input
										type="checkbox"
										name="pregnantMRI"
										value="No"
										checked={formData.pregnantMRI.includes('No')}
										onChange={handleChange}
									/>
									No
								</label>
								<label>
									<input
										type="checkbox"
										name="pregnantMRI"
										value="N/A"
										checked={formData.pregnantMRI.includes('N/A')}
										onChange={handleChange}
									/>
									Not Applicable
								</label>
							</div>

							<label htmlFor="paidProfessionalSport">
								Are you involved in paid professioinal sports? *
							</label>
							<div className={styles['checkbox-group']}>
								<label>
									<input
										type="checkbox"
										name="paidProfessionalSport"
										value="Yes"
										checked={formData.paidProfessionalSport.includes('Yes')}
										onChange={handleChange}
									/>
									Yes
								</label>
								<label>
									<input
										type="checkbox"
										name="paidProfessionalSport"
										value="No"
										checked={formData.paidProfessionalSport.includes('No')}
										onChange={handleChange}
									/>
									No
								</label>
							</div>
						</>
					)}
				</>
			)}

			{formData.imageTestTypeRequested === 'Other' && (
				<>
					<div className={styles['form-group']}>
						<label htmlFor="otherImagingTestRequested">
							<u>Other imaging:</u> please specify this here.
						</label>
						<input
							type="text"
							id="otherImagingTestRequested"
							name="otherImagingTestRequested"
							value={formData.otherImagingTestRequested}
							onChange={handleChange}
							required
							className={styles['form-select']}
						/>
					</div>

					<label htmlFor="mostPreferredImageTestLocation">
						Please indicate the most convenient location for you to have this test performed.
					</label>
					<input
						type="text"
						id="mostPreferredImageTestLocation"
						name="mostPreferredImageTestLocation"
						value={formData.mostPreferredImageTestLocation}
						onChange={handleChange}
					/>
				</>
			)}

			<label htmlFor="complexRequestNordClinic">
				For any complex requests, please provide below the specific wording from{' '}
				{formData.referringClinician}. Please forward the email/letter from{' '}
				{formData.referringClinician} to{' '}
				<a href="mailto:customers@sirkkaltd.com">
					<u>customers@sirkkaltd.com</u>
				</a>{' '}
				if you have one.
			</label>
			<input
				type="text"
				id="complexRequestNordClinic"
				name="complexRequestNordClinic"
				value={formData.complexRequestNordClinic}
				onChange={handleChange}
			/>

			<div className={styles['form-group']}>
				<label htmlFor="lastImageScanDate">When did you have your last X-Ray, CT or DEXA?</label>
				<input
					type="date"
					id="lastImageScanDate"
					name="lastImageScanDate"
					value={formData.lastImageScanDate}
					onChange={handleChange}
					required
				/>
			</div>
		</>
	);
};

export const ECGForm = ({ formData, handleChange, handleBooleanToggle }: any) => {
	return (
		<>
			<label htmlFor="selectedECGLocation">
				Please select the preferred location to have your <b>ECG</b> taken.
			</label>
			<small>
				The pricing for this test is currently being revised, so please email us or complete this
				form and we will be in touch with costs.
			</small>
			<select
				id="selectedECGLocation"
				name="selectedECGLocation"
				value={formData.selectedECGLocation}
				onChange={handleChange}
				required
				className={styles['form-select']}
			>
				<option value="" disabled>
					Select a location
				</option>
				<option value="Cardiff">Cardiff</option>
				<option value="Leeds">Leeds</option>
				<option value="London">London</option>
				<option value="Glasgow">Glasgow</option>
				<option value="Liverpool">Liverpool</option>
				<option value="Manchester">Manchester</option>
				<option value="Newport">Newport</option>
				<option value="Newton-le-Willows">Newton-le-Willows</option>
				<option value="West Sussex">West Sussex</option>
				<option value="Other">Other</option>
			</select>

			{formData.selectedECGLocation === 'Other' && (
				<div className={styles['form-group']}>
					<label htmlFor="otherECGLocation">Please specify your location</label>
					<input
						type="text"
						id="otherECGLocation"
						name="otherECGLocation"
						value={formData.otherECGLocation}
						onChange={handleChange}
						required
						className={styles['form-select']}
					/>
				</div>
			)}

			<label>
				I hereby consent for resting ECG printout to be sent to Sirkka Health to be shared with my
				referring clinic/clinicians.
			</label>
			<div className={styles['toggle-buttons']}>
				<button
					type="button"
					className={`${styles['toggle-button']} ${
						formData.consentConfirmationECG === true ? styles['active'] : ''
					}`}
					onClick={() => handleBooleanToggle('consentConfirmationECG', true)}
				>
					Yes
				</button>
				<button
					type="button"
					className={`${styles['toggle-button']} ${
						formData.consentConfirmationECG === false ? styles['active'] : ''
					}`}
					onClick={() => handleBooleanToggle('consentConfirmationECG', false)}
				>
					No
				</button>
			</div>
		</>
	);
};
